"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const useGlobalObject = require("./useGlobalObject");
const fastFreshId = require("./fastFreshId");
const hygiene = require("./hygiene");
const util_1 = require("@stopify/util");
var fastFreshId_1 = require("./fastFreshId");
exports.fresh = fastFreshId_1.fresh;
exports.nameExprBefore = fastFreshId_1.nameExprBefore;
exports.reset = fastFreshId_1.reset;
exports.init = fastFreshId_1.init;
const visitor = {
    Program(path, state) {
        fastFreshId.init(path);
        util_1.transformFromAst(path, [
            [hygiene.default, state.opts]
        ]);
        if (state.opts.global !== undefined) {
            util_1.transformFromAst(path, [
                [useGlobalObject.plugin, state.opts]
            ]);
        }
        path.stop();
    }
};
function plugin() {
    return { visitor };
}
exports.plugin = plugin;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi90cy9pbmRleC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOztBQU9BLHFEQUFxRDtBQUNyRCw2Q0FBNkM7QUFDN0MscUNBQXFDO0FBQ3JDLHdDQUFrRDtBQUVsRCw2Q0FBbUU7QUFBMUQsOEJBQUEsS0FBSyxDQUFBO0FBQUUsdUNBQUEsY0FBYyxDQUFBO0FBQUUsOEJBQUEsS0FBSyxDQUFBO0FBQUUsNkJBQUEsSUFBSSxDQUFBO0FBRTNDLE1BQU0sT0FBTyxHQUFZO0lBQ3JCLE9BQU8sQ0FBQyxJQUFJLEVBQUUsS0FBWTtRQUN0QixXQUFXLENBQUMsSUFBSSxDQUFDLElBQUksQ0FBQyxDQUFDO1FBQ3ZCLHVCQUFnQixDQUFDLElBQUksRUFBRTtZQUNuQixDQUFFLE9BQU8sQ0FBQyxPQUFPLEVBQUUsS0FBSyxDQUFDLElBQUksQ0FBRTtTQUNsQyxDQUFDLENBQUM7UUFDSCxJQUFJLEtBQUssQ0FBQyxJQUFJLENBQUMsTUFBTSxLQUFLLFNBQVMsRUFBRTtZQUNqQyx1QkFBZ0IsQ0FBQyxJQUFJLEVBQUU7Z0JBQ25CLENBQUUsZUFBZSxDQUFDLE1BQU0sRUFBRSxLQUFLLENBQUMsSUFBSSxDQUFFO2FBQ3pDLENBQUMsQ0FBQztTQUNOO1FBQ0QsSUFBSSxDQUFDLElBQUksRUFBRSxDQUFDO0lBQ2hCLENBQUM7Q0FDSixDQUFBO0FBRUQsU0FBZ0IsTUFBTTtJQUNsQixPQUFPLEVBQUUsT0FBTyxFQUFFLENBQUM7QUFDdkIsQ0FBQztBQUZELHdCQUVDIn0=


//////////////////
// WEBPACK FOOTER
// ../hygiene/dist/ts/index.js
// module id = 10
// module chunks = 0